import styled, { keyframes } from 'styled-components';

import { CONTENT_ANIMATION_DURATION } from './constants';

export const ContentKeyframes = keyframes`
  0% {
    opacity: 0;
      transform: translateX(-100vw)
  }
  100% {
    opacity: 1;
      transform: translateX(0vw)
  }
`;

export const Container = styled.div`
  width: ${({ theme }) => theme.spacing['7Xl']};
  height: ${({ theme }) => theme.spacing['6Xl']};
`;

export const Content = styled.div`
  animation: ${ContentKeyframes};
  animation-duration: ${CONTENT_ANIMATION_DURATION}ms;
  animation-timing-function: ease-in;
  animation-delay: 0;
  animation-direction: normal;
  animation-fill-mode: forwards;
`;
